import React from 'react';
import Hero from '../components/Hero';
import FinancialServices from '../components/FinancialServices';
import ServicesOverview from '../components/ServicesOverview';
import Testimonials from '../components/Testimonials';
import CallToAction from '../components/CallToAction';

const Home = () => {
  return (
    <div className="home">
      <Hero />
      <FinancialServices />
      <ServicesOverview />
      <Testimonials />
      <CallToAction />
    </div>
  );
};

export default Home; 